import { assets } from "../../data/sep26Data";

// Estado vacío para secciones que esperan datos reales de la temporada.
export const Empty26 = ({ title, text, testId }) => (
  <div
    data-testid={testId}
    className="relative flex min-h-[220px] flex-col items-start justify-center overflow-hidden border p-8 sm:p-12"
    style={{ borderColor: "var(--line)", background: "rgba(18,26,69,.35)" }}
  >
    <img
      src={assets.crest}
      alt=""
      aria-hidden="true"
      className="absolute -bottom-10 -right-8 w-[220px] opacity-[0.06]"
      style={{ filter: "grayscale(1) brightness(2)" }}
      loading="lazy"
    />
    <p className="display relative text-[clamp(26px,3vw,40px)]">{title}</p>
    <p className="serif relative mt-3 max-w-[42ch] text-lg" style={{ color: "var(--muted)" }}>{text}</p>
  </div>
);
